import { render, screen } from "@testing-library/react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Link } from "react-router-dom";

import Header from "../component/header";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import IndFlag from "../img/flag-india.png";

import trophy from "../img/trophy.png";

import RightBanner from "../img/right-banner.png";
import RightBanner1 from "../img/right-banner-1.png";
import Dice from "../img/dise.png";
import C1 from "../img/c-01.png";
import C2 from "../img/c-2.png";
import C3 from "../img/c-3.png";
import C4 from "../img/item1.png";
import C5 from "../img/item2.png";
import C6 from "../img/item3.png";
import C7 from "../img/item4.png";
import C8 from "../img/item5.png";
import C9 from "../img/item6.png";
import Banner from "../img/casino-banner.png";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { useEffect } from "react";
import { isEmpty, startCase } from "lodash";
import { useState } from "react";
import {
  AviatorGames,
  BetGames,
  DepositWithrawDataArray,
  EvolutionNew,
  EzugiNew,
  gamesLiveArray,
  PokerGames,
  RoyalGamming,
  RoyalGammingNew,
  Vivo,
} from "../Utils/constants";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import SubCasino from "../component/SubCasino";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
function CasinoPage() {
  const params = useParams();
  let {
    launchEGTCasino,
    user,
    launchCasino,
    dolaunchCasinoNew,
    dolaunchCasinoRyoal,
    setLoginModal,
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const [key, setKey] = useState("poker");
  useEffect(() => {
    document.getElementById("loading").style.display = "flex";
    if (!isEmpty(params?.type)) {
      if (params?.type == "Indian_Poker") {
        setKey("poker");
      } else if (params?.type == "Royal Gamming") {
        setKey("royal");
      } else {
        setKey(params?.type);
        if (!isEmpty(obj[params?.type])) {
          setSubCasino(obj[params?.type][0]);
        }
      }
    } else {
      setKey("poker");
    }
  }, [params]);

  useEffect(() => {
    let timer = setTimeout(() => {
      document.getElementById("loading").style.display = "none";
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [params]);
  const [subCasino, setSubCasino] = useState("");
  const [array, setArray] = useState([]);
  useEffect(() => {
    setArray({
      live:
        gamesLiveArray?.filter((res) => {
          return ["ROULETTE", "GAME-SHOWS"].includes(res?.type);
        }) || [],
      evolition:
        gamesLiveArray?.filter((res) => {
          return res?.platForm == "EVOLUTION";
        }) || [],
      awc:
        gamesLiveArray?.filter((res) => {
          return res?.type == "AWC";
        }) || [],
      sexy:
        gamesLiveArray?.filter((res) => {
          return res?.platForm == "SEXYBCRT";
        }) || [],
      dice:
        gamesLiveArray?.filter((res) => {
          return res?.type == "DICE";
        }) || [],
      table:
        gamesLiveArray?.filter((res) => {
          return res?.type == "TABLE";
        }) || [],
      slot:
        gamesLiveArray?.filter((res) => {
          return res?.type == "SLOT";
        }) || [],
      fishing:
        gamesLiveArray?.filter((res) => {
          return res?.type == "FISHING";
        }) || [],
      egame:
        gamesLiveArray?.filter((res) => {
          return res?.type == "EGAME";
        }) || [],
    });
  }, []);

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (!isEmpty(res?.gameid)) {
        launchEGTCasino({
          platForm: res?.platForm,
          gameType: res?.gameType,
          casinoType: res?.casinoType,
          gameid: res?.gameid,
        });
      } else {
        launchCasino({
          platForm: res?.platForm,
          gameType: res?.gameType,
          casinoType: res?.casinoType,
          isLobbyTrue: res?.isLobbyTrue,
        });
      }
      // }
    } else {
      setLoginModal(true);
    }
  };
  const handelChange = (res, game, type) => {
    if (!isEmpty(user)) {
      dolaunchCasinoNew(
        game == "poker"
          ? {
              gameCode: res?.gameCode,
              legacy: res?.legacy,
              type: type,
            }
          : {
              gameCode: res?.gameCode,
              legacy: res?.legacy,
              type: type,
            }
      );
    } else {
      setLoginModal(true);
    }
  };
  const ImageWithFallback = ({ src, fallbackSrc, alt, ...props }) => {
    const [imageSrc, setImageSrc] = useState(src);

    const handleError = () => {
      setImageSrc(fallbackSrc);
    };

    return (
      <LazyLoadImage
        src={imageSrc}
        alt={alt}
        onError={handleError}
        effect="blur" // Optional effect
        {...props}
      />
    );
  };
  return (
    <Layout>
      <Col md={12}>
        {/* <div data-aos="zoom-in-up" className="mb-2">
          <img src={Banner} style={{ maxWidth: "100%",height:"200px",objectFit:"contain" }} />
        </div> */}

        <div data-aos="zoom-in-up" className="casinoTabs mb-3">
          <Tabs
            activeKey={key}
            onSelect={(e) => {
              setKey(e);
              if (!isEmpty(obj[e])) {
                setSubCasino(obj[e][0]);
              }
            }}
            id="uncontrolled-tab-example"
            className="mb-2"
          >
            <Tab eventKey="poker" title="Indian Poker">
              <Row>
                {PokerGames?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.image} />
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handelChange(res, "poker", "first")}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Casino" title="Casino">
              <Row>
                {DepositWithrawDataArray?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <ImageWithFallback
                          src={res?.image || res?.url_thumb}
                          fallbackSrc={
                            "https://cdn.dreamdelhi.com/gap-logo.webp"
                          }
                        />
                        <h2>
                          <a href="#">{res?.title || res?.game_name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (res?.newType == "Evo") {
                                navigate("/casino/Evolution");
                              } else if (res?.legacy == "aura") {
                                handelChange(res, "poker", "first");
                              } else if (!isEmpty(res?.url_thumb)) {
                                dolaunchCasinoRyoal(res);
                              } else {
                                handel(res);
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Evolution" title="Evolution">
              <Row>
                {EvolutionNew?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (isEmpty(user)) {
                                setLoginModal(true);
                              } else {
                                dolaunchCasinoRyoal({
                                  game_code: res?.game_code,
                                  game_id: res?.game_id,
                                  game_name: res?.name,
                                  provider_name: res?.provider_name,
                                  category: res?.category,
                                  deviceType: "web",
                                  isLobby:
                                    res?.category == "LOBBY" ? true : false,
                                });
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>{" "}
            <Tab eventKey="Ezugi" title="Ezugi">
              <Row>
                {EzugiNew?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (isEmpty(user)) {
                                setLoginModal(true);
                              } else {
                                dolaunchCasinoRyoal({
                                  game_code: res?.gameCode,
                                  game_id: res?.gameId,
                                  game_name: res?.name,
                                  provider_name: "EZUGI",
                                  category: res?.Cat,
                                  deviceType: "web",
                                  isLobby:
                                    res?.category == "LOBBY" ? true : false,
                                });
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="royal" title={"Royal Gamming"}>
              <Row>
                {RoyalGammingNew?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <ImageWithFallback
                          src={res?.img}
                          fallbackSrc={
                            "https://cdn.dreamdelhi.com/gap-logo.webp"
                          }
                        />

                        <h2 style={{ marginTop: "6px" }}>
                          <a href="/CasinoDetail">{res?.game_name}</a>
                        </h2>
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (isEmpty(user)) {
                                setLoginModal(true);
                              } else {
                                dolaunchCasinoRyoal({
                                  game_code: res?.gameCode,
                                  game_id: res?.gameId,
                                  game_name: res?.name,
                                  provider_name: "RG",
                                  category: res?.Cat,
                                  deviceType: "web",
                                  isLobby:
                                    res?.category == "LOBBY" ? true : false,
                                });
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Aviator" title="Aviator">
              <Row>
                {AviatorGames?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.image} />
                        <h2>
                          <a href="/CasinoDetail">{res?.title}</a>
                        </h2>
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handelChange(res, "", "first")}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Live" title="Live">
              <Row>
                {array?.live?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>{" "}
            <Tab eventKey="Sexy" title="Sexy">
              <Row>
                {array?.sexy?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Table" title="Table">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.table?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.table
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Slot" title="Slot">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.slot?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.slot
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>{" "}
            <Tab eventKey="Dice" title="Dice">
              <Row>
                {array?.dice?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Fishing" title="Fishing">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.fishing?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.fishing
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Egame" title="Egame">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.egame?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.egame
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="AWC" title="AWC">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.awc?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.awc
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>{" "}
            <Tab eventKey="Vivo" title="Vivo">
              <Row>
                {Vivo?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        {/* <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "} */}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (isEmpty(user)) {
                                setLoginModal(true);
                              } else {
                                dolaunchCasinoRyoal({
                                  game_code: res?.gameCode,
                                  game_id: res?.gameId,
                                  game_name: res?.name,
                                  provider_name: "DC",
                                  category: res?.Cat,
                                  deviceType: "web",
                                  isLobby:
                                    res?.category == "LOBBY" ? true : false,
                                });
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="BetGames" title="Bet Games">
              <Row>
                {BetGames?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        {/* <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "} */}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (isEmpty(user)) {
                                setLoginModal(true);
                              } else {
                                dolaunchCasinoRyoal({
                                  game_code: res?.gameCode,
                                  game_id: res?.gameId,
                                  game_name: res?.name,
                                  provider_name: startCase(res?.category),
                                  category: "LIVE",
                                  deviceType: "web",
                                  isLobby:
                                    res?.category == "LOBBY" ? true : false,
                                });
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
          </Tabs>
        </div>
      </Col>
    </Layout>
  );
}

export default CasinoPage;

const live = ["SEXY", "EVO", "PT", "PP", "HOTROAD"];
const table = ["KINGMAKER", "NETENT", "JILI"];
const slot = [
  "PP",
  "KINGMAKER",
  "DRAGOONSOFT",
  "NETENT",
  "SPADE",
  "PT",
  "JDB",
  "FC",
  "JILI",
];
const fishing = ["SPADE", "JDB", "JILI"];
const egame = ["SPRIBE", "PP", "JDB"];
const awc = ["BG", "BTG", "E1SPORT", "NLC", "RT", "SV388", "YesBingo", "YL"];
const obj = {
  Live: live,
  Slot: slot,
  Table: table,
  Fishing: fishing,
  Egame: egame,
  AWC: awc,
};
